import { render, staticRenderFns } from "./ActionColumn.vue?vue&type=template&id=6cd032f3&scoped=true&"
import script from "./ActionColumn.vue?vue&type=script&lang=js&"
export * from "./ActionColumn.vue?vue&type=script&lang=js&"
import style0 from "./ActionColumn.vue?vue&type=style&index=0&id=6cd032f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd032f3",
  null
  
)

export default component.exports